import ResetSuccess from './ResetSuccess';
export default ResetSuccess;
